import { queryClient } from '../../../../v4/migration/queryClientSingleton';
import { createGeolocationApi } from '../../../api/geolocation/geolocation.api.google';
import { myErrorService } from '../../front/ErrorService/ErrorService.connected';
import { createGeolocationService } from './GeolocationService.impl';

export const myGeolocationService = createGeolocationService(
  queryClient,
  createGeolocationApi(),
  myErrorService
);
